import { Tag } from 'antd';
import ITagProps from './entities/ITagProps';

const BCTag = (props: ITagProps) => (
	<Tag
		color={props.color}
		closeIcon={props.closeIcon}
		closable={props.closable}
		onClose={props.onClose}
		icon={props.icon}
		style={props.style}
		className={props.className}
	>
		{props.text}
	</Tag>
);
export default BCTag;
export { ITagProps };
